import { formatPrice } from "helpers/common";
import { useFlightContext } from "hooks/flight/useFlightContext";
import { Card, CardBody, CardHeader, CardTitle, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SideBar = () => {
    const { t } = useTranslation();
    const { airValidateResults } = useFlightContext();
    const flight = airValidateResults?.flight;

    return (
        <Row className="g-4 px-2 md:px-0">
            <Card className="rounded-2 border">
                <CardHeader className="border-bottom bg-white">
                    <CardTitle
                        as="div"
                        className="text-default fs-5 fw-bold mb-0"
                    >
                        {t("fareSummary")}
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div className=" d-flex flex-column gap-1 ">
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("baseFare")}
                            </span>
                            <span className="fs-5">
                                {formatPrice(
                                    flight?.recommendation?.price
                                        ?.detailed_price?.total
                                ).replace("DA", t("DA"))}
                            </span>
                        </li>
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("discount")}
                            </span>
                            <span className="fs-5 text-success">
                                {" "}
                                - 0,00 {"DA".replace("DA", t("DA"))}
                            </span>
                        </li>
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("otherServices")}
                            </span>
                            <span className="fs-5 text-danger">
                                {" "}
                                + 0,00 {"DA".replace("DA", t("DA"))}
                            </span>
                        </li>
                    </div>
                </CardBody>
                <div className="card-footer border-top bg-white  ">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-default fs-5 fw-normal mb-0">
                            {t("total")}
                        </span>
                        <span className="text-default text-md fw-normal mb-0 fs-5">
                            {formatPrice(
                                flight?.recommendation?.price?.detailed_price
                                    ?.total
                            ).replace("DA", t("DA"))}
                        </span>
                    </div>
                </div>
            </Card>
            <Card className="border p-4">
                <CardTitle as="div" className="mb-3">
                    <div className="mb-0 text-default fs-5 fw-bold ">
                        {t("needHelp")}
                    </div>
                </CardTitle>
                <p className="mb-2">{t("needHelpDescription")}</p>
                <div className="text-default fs-4 fw-bold ">+213 770268725</div>
            </Card>
        </Row>
    );
};
export default SideBar;
